export default "__VITE_ASSET__BZFne47J__"